import axios from 'axios';
import { USER_TOKEN_STORAGE_KEY } from '../pages/LoginProvider/constants';
import StorageService from './storageService';
export const BASE_URL =
  process.env.REACT_APP_API_PATH || window.location.origin;

/*Axios client*/
let client;
const init = (headers = {}, params = {}, signal) => {
  client = axios.create({
    baseURL: BASE_URL,
    headers: {
      token: 'token',
      ...headers,
    },
    signal,
    params,
  });
};
const tokenInit = (token, headers = {}, params = {}, signal) => {
  client = axios.create({
    baseURL: BASE_URL,
    headers: {
      token: token,
      ...headers,
    },
    signal,
    params,
  });
};

/*generic method to call APIs*/
export const apiCall = (
  method,
  url,
  body = null,
  headers = null,
  params = null,
  signal = null,
) => {
  // change to this USER_TOKEN_STORAGE_KEY
  let token = StorageService.getValue(USER_TOKEN_STORAGE_KEY);
  if (token) tokenInit(token, headers, params, signal);
  else init(headers, params, signal);
  const parseResponse = (response) => response.data;
  const onError = (error) => {
    if (error.message === 'Network Error') {
      // The user doesn't have internet
      return Promise.reject(error);
    }
    try {
      switch (error?.response?.status) {
        case 400:
          break;
        case 401:
          window.location.reload();
          localStorage.clear();
          break;
        case 404:
          // Show 404 page
          break;
        case 500:
          // Serveur Error redirect to 500
          break;
        case 504:
          return Promise.reject({
            message: 'Servers are busy, Please try again after some time',
          });
        default:
          // Unknow Error
          break;
      }
    } catch (e) {
      console.error('Server Down please try after sometime');
    }
    return Promise.reject(error.response || error.message);
  };
  return client({
    method,
    url,
    data: body,
  })
    .then(parseResponse)
    .catch(onError);
};
